import React from 'react';
import {
  Select,
  Button,
  ButtonType
} from 'syngenta-digital-cropwise-react-ui-kit';
import { Modal } from 'antd';
import { CropZoneRecord } from 'components/CropZonesTable/types';
import LayoutStrings from 'screens/Applications&WorkOrders/StepsLayout/Constants/layoutStrings';
import {
  AREA_TYPE_REPORTED,
  AREA_TYPE_BOUNDARY,
  AreaType
} from 'screens/Applications&WorkOrders/StepsLayout/Constants/areaTypeConstants';
import ChevronDown from 'assets/chevron_down.svg?react';
import ChevronUp from 'assets/chevron_up.svg?react';

interface CropZoneEditModalProps {
  open: boolean;
  editingRow: { index: number; record: CropZoneRecord } | null;
  selectedAreaType: AreaType;
  isDropdownVisible: boolean;
  onAreaTypeChange: (value: AreaType) => void;
  onDropdownVisibleChange: (visible: boolean) => void;
  onCancel: () => void;
  onSave: () => void;
}

const CropZoneEditModal: React.FC<CropZoneEditModalProps> = ({
  open,
  editingRow,
  selectedAreaType,
  isDropdownVisible,
  onAreaTypeChange,
  onDropdownVisibleChange,
  onCancel,
  onSave
}) => (
  <Modal
    open={open}
    onCancel={onCancel}
    footer={null}
    centered
    closable
    width={580}
    transitionName=""
    maskTransitionName=""
    style={{ height: '294px' }}
    styles={{
      body: { height: '100%', display: 'flex', flexDirection: 'column' }
    }}
  >
    {editingRow && (
      <div className="flex flex-col justify-between flex-1">
        <div>
          <div
            className="text-base font-normal leading-6 mb-0"
            style={{ color: '#696F88' }}
          >
            {editingRow.record.fieldName}
          </div>
          <div className="text-xl font-semibold leading-7 mt-0">
            {editingRow.record.name}
          </div>
          <div
            className="mt-2 text-sm font-normal leading-5"
            style={{ color: '#4D5165' }}
          >
            {LayoutStrings.cropZones.cropZoneModal.description}
          </div>
        </div>
        <div className="mt-6">
          <label
            htmlFor="crop-zone-acreage-select"
            className="text-sm font-normal leading-5"
            style={{ color: '#696F88' }}
          >
            {LayoutStrings.cropZones.cropZoneModal.cropZoneAcreage}
          </label>
          <Select
            id="crop-zone-acreage-select"
            value={selectedAreaType}
            onChange={onAreaTypeChange}
            placeholder="Select area type"
            style={{ width: '100%' }}
            suffixIcon={
              isDropdownVisible ? (
                <ChevronUp width={18} height={18} />
              ) : (
                <ChevronDown width={18} height={18} />
              )
            }
            onDropdownVisibleChange={onDropdownVisibleChange}
          >
            {(() => {
              const { reportedArea, boundaryArea } = editingRow.record;
              return (
                <>
                  <Select.Option value={AREA_TYPE_REPORTED}>
                    {LayoutStrings.cropZones.cropZoneModal.reportedArea}
                    {` (${(reportedArea || 0).toFixed(2)} ac)`}
                  </Select.Option>
                  <Select.Option value={AREA_TYPE_BOUNDARY}>
                    {LayoutStrings.cropZones.cropZoneModal.boundaryArea}
                    {` (${(boundaryArea || 0).toFixed(2)} ac)`}
                  </Select.Option>
                </>
              );
            })()}
          </Select>
        </div>
        <div className="flex justify-end gap-2 mt-6 pt-1 modal-footer-buttons">
          <Button
            type={ButtonType.outline}
            size="large"
            onClick={onCancel}
            className="modal-button"
          >
            {LayoutStrings.cropZones.cropZoneModal.cancel}
          </Button>
          <Button
            type={ButtonType.primary}
            size="large"
            onClick={onSave}
            className="modal-button"
          >
            {LayoutStrings.cropZones.cropZoneModal.save}
          </Button>
        </div>
      </div>
    )}
  </Modal>
);

export default CropZoneEditModal;
